export const VOTE_FOR_PLAYER = "VOTE_FOR_PLAYER";

export const SUBMIT_VOTE_BEGIN = "SUBMIT_VOTE_BEGIN";
export const SUBMIT_VOTE_FAIL = "SUBMIT_VOTE_FAIL";
export const SUBMIT_VOTE_SUCCESS = "SUBMIT_VOTE_SUCCESS";
export const CLEAR_VOTE_ERRORS = "CLEAR_VOTE_ERRORS";
